var _defs, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPressureF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.62 491.62",
    fill: "#F4A335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{ \n                fill:none;\n                stroke:#fff;\n                stroke-miterlimit:10;\n                stroke-width:19px;\n                }\n            .cls-2{\n                fill:#F4A335;\n                }\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 242.69,
    cy: 242.32,
    r: 150.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M441.08,0H50A50.61,50.61,0,0,0-.28,50.22V441.31A50.61,50.61,0,0,0,50,491.57h391.1a50.61,50.61,0,0,0,50.26-50.26V50.22A50.61,50.61,0,0,0,441.08,0ZM245.53,408.37c-89.66,0-162.61-72.94-162.61-162.61s73-162.6,162.61-162.6,162.6,72.94,162.6,162.6S335.19,408.37,245.53,408.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.53,107.16c-76.43,0-138.61,62.18-138.61,138.6S169.1,384.37,245.53,384.37s138.6-62.18,138.6-138.61S322,107.16,245.53,107.16Zm76.56,66.89-44.33,73.28A32.27,32.27,0,1,1,245.3,213.5l72.43-43.82a3.18,3.18,0,0,1,4.36,4.37Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureF);
export default __webpack_public_path__ + "static/media/pressure_F.a0ffe716.svg";
export { ForwardRef as ReactComponent };